export class UserCredentials {
    constructor(
        public userID: string,
        public token: string,
        public ttl: number
    ) {}
}
